import type { SupportedLocale } from "@runcheetah/shared/locale";

import enMessages from "@/i18n/messages/en.json";
import nlMessages from "@/i18n/messages/nl.json";
import roMessages from "@/i18n/messages/ro.json";

// Re-export locale primitives from the shared package so existing
// imports from "@/i18n" continue to work throughout the app.
export {
  LOCALE_LABELS,
  SUPPORTED_LOCALES,
  resolveLocale,
  type SupportedLocale,
} from "@runcheetah/shared/locale";

const messages: Record<SupportedLocale, Record<string, string>> = {
  en: enMessages,
  nl: nlMessages,
  ro: roMessages,
};

export function getMessages(locale: SupportedLocale): Record<string, string> {
  return messages[locale];
}
